// extracted by mini-css-extract-plugin
module.exports = {"gallery":"gallery_gallery__POEFc","zoom":"gallery_zoom__9Y7yu"};